module.exports = __webpack_public_path__ + "img/codelock.4b52a37f.png";